import React from 'react';
import { find, get } from 'lodash';

import BaseNode from './BaseBlockNode';
import { renderValue } from '../../helpers/node';
import { ROOT_NODE_TYPE } from '../../../constants';
import { getAdjustedMaxLoad } from '../../../Editor/NodeForm/rules/constraint';
import { renderPhasesParams } from '../../../constants/phases';

function ConstraintNode(props) {
  const {
    maxLoad, adjustedMaxLoad, nodes,
    presentLoadPhA, presentLoadPhB, presentLoadPhC,
    presentPowerPhA, presentPowerPhB, presentPowerPhC,
  } = props;
  let adjustedValue = adjustedMaxLoad;

  const staticParams = [
    { label: 'Max Load', value: renderValue(maxLoad, 'A') },
  ];

  if (window.location.pathname.includes('editor')) {
    const rootNode = find(nodes, { topologyNodeType: ROOT_NODE_TYPE });
    const safetyMargin = get(rootNode, 'staticSection.safetyMarginPercent');

    adjustedValue = getAdjustedMaxLoad(maxLoad, safetyMargin);
    staticParams.push({ label: 'Adjusted Max Load', value: renderValue(adjustedValue, 'A') });
  }

  return (
    <BaseNode
      {...props}
      staticParams={staticParams}
      dynamicParams={[
        ...renderPhasesParams({
          presentLoadPhA,
          presentLoadPhB,
          presentLoadPhC,
          presentPowerPhA,
          presentPowerPhB,
          presentPowerPhC,
        }),
      ]}
    />
  );
}

export default ConstraintNode;
